import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../input/date'
import Filters from '../global_filters'
import ListView from 'bstrap-react-mobx-admin/view/list'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import filesize from 'file-size'
import { LINK_PPROLLS_UPLOAD } from '../../constants/link_constants'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'

const UploadingListView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.PPROLLS_UPLOAD)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const ValidityField = ({ attr, val }) => {
    function errorDesc (e) {
      if (e.url) {
        return `missing: ${e.url}`
      }
      return JSON.stringify(e)
    }
    switch (val) {
    case undefined:
    case null:
      return <span>?</span>
    case 'ok':
    case '[]':
      return <span className='glyphicon glyphicon-ok' />
    default: {
      val = val && JSON.parse(val)
      const tooltipContent = val && (
        <Tooltip id={`tooltip${attr}`} className='uplerror'>
          <ul>
            {
              val.map((i, idx) => {
                return <li key={idx}>{errorDesc(i)}</li>
              })
            }
          </ul>
        </Tooltip>
      )
      return (
        val && <OverlayTrigger placement='right' overlay={tooltipContent}>
          <span className='glyphicon glyphicon-exclamation-sign' />
        </OverlayTrigger>
      )
    }
    }
  }

  const fields = [
    (attr, row) => (<TextField attr={attr} val={row[attr]} Component={({ text }) => (
      <a href='javascript:void(0)' onClick={() => store.detailClicked(row)}>{text}</a>
    )} />),
    (attr, row) => {
      try {
        const status = JSON.parse(row[attr])
        if (status.failed) {
          return <TextField attr={attr} val={store.__('failed')} />
        }
        return <TextField attr={attr} val={status.step} />
      } catch (_) {
        if (store.isFileMissing(row)) {
          return <span>{store.__('in progress')} </span>
        } else {
          return <TextField attr={attr} val={row[attr]} />
        }
      }
    },
    (attr, row) => (<ValidityField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<OptionsField attr={attr} val={row[attr]}
      options={store.options.get('Languages')}
      labelattr='text' />),
    (attr, row) => (<span title={row[attr] > 0
      ? row[attr] + ' B = ' + filesize(row[attr]).human()
      : '0 B'}>{filesize(row[attr]).human('si')}</span>),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_to} />),
    (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_from} />)
  ]

  const batchActions = () => {
    return (
      <button className={defaultConst.ACTION_BUTTON_CLASS2} type='button' onClick={store.batchDelete.bind(store)}>
        <span className='glyphicon glyphicon-remove' />&nbsp;{store.__('Delete')}</button>
    )
  }

  const filters = {
    id_like: {
      title: 'id',
      component: (props) => (<TextInput {...props} />)
    },
    state_like: {
      title: 'state',
      component: (props) => (<TextInput {...props} />)
    },
    validity_like: {
      title: 'validity',
      component: (props) => (<TextInput {...props} />)
    },
    regions_like: {
      title: 'regions',
      component: (props) => (<TextInput {...props} />)
    },
    lang_like: {
      title: 'language',
      component: (props) => (<TextInput {...props} />)
    },
    final_length_like: {
      title: 'original size',
      component: (props) => (<TextInput {...props} />)
    },
    original_filename_like: {
      title: 'original filename',
      component: (props) => (<TextInput {...props} />)
    },
    s3_filename_like: {
      title: 's3_filename',
      component: (props) => (<TextInput {...props} />)
    },
    valid_from__from: {
      title: 'valid from',
      component: (props) => (
        <div>
          <DateInput hideControlLabel asFilter {...props} />
          <DateInput hideControlLabel asFilter {...props} attr={props.attr + '__to'} />
        </div>
      )
    },
    valid_to__from: {
      title: 'valid to',
      component: (props) => (
        <div>
          <DateInput hideControlLabel asFilter {...props} />
          <DateInput hideControlLabel asFilter {...props} attr={props.attr + '__to'} />
        </div>
      )
    }
  }

  return (<ListView
    store={store.cv}
    helper={store.helpFor(LINK_PPROLLS_UPLOAD)}
    fields={fields}
    filters={() => Filters(store, filters)}
    onAddClicked={store.addClicked.bind(store)}
    batchActions={batchActions} />)
}
export default observer(UploadingListView)
